const AUTHZ_TOKEN_TTL_MS = 10_000;

let authzToken: { token: string; setAt: number } | undefined;

/** Header atlas reads its SpiceDB `at_least_as_fresh` ZedToken from. */
export const AUTHZ_TOKEN_HEADER = 'X-Authz-Token';

/** ZedToken from this tab's most recent atlas ACL write, if set in the last 10s. */
export const getAuthzToken = () =>
  authzToken && Date.now() - authzToken.setAt < AUTHZ_TOKEN_TTL_MS
    ? authzToken.token
    : undefined;

/** Remembers an atlas ACL write's ZedToken. */
export const setAuthzToken = (token: string | null | undefined) => {
  if (token) {
    authzToken = { token, setAt: Date.now() };
  }
};
